import { mergeStyles, Stack, Text } from '@fluentui/react';
import Chart, { ReactGoogleChartProps } from 'react-google-charts';

import ContentBox from '../../ContentBox';

type Props = {
  Title: string;
  ChartProps: ReactGoogleChartProps;
};

export default (props: Props) => {
  return (
    <Stack grow={3} className={blockStyles}>
      <ContentBox>
        <Text variant="xLarge" style={{ marginLeft: "8px" }}>
          {props.Title}
        </Text>
        <Chart {...props.ChartProps} width={"100%"} height={"350px"} />
      </ContentBox>
    </Stack>
  );
};

const blockStyles = mergeStyles({
  minWidth: "30%",
  padding: "2px",
});
